export const ROUTES = {
  ADMIN: {
    DASHBOARD: "/admin/dashboard",
    DASHBOARD_CALENDAR: "/admin/dashboard/calendar",
    ORGANIZATIONS: "/admin/organizations",
    GESTION: "/admin/gestion",
    EVENT: "/admin/event",
    STATS_BY_SPORT: "/admin/stats-by-sport",
  },
  PUBLIC: {
    LANDING: "/landing",
    SIGNIN: "/signin",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    EVENT: "/event",
    TOURNAMENT: "/torneo",
    RANKINGS: "/rankings",
    ORGANIZATION: "/organization",
  },
};

export const adminEventRoute = (eventId) => `${ROUTES.ADMIN.EVENT}/${eventId}`;
export const adminEventTournamentsRoute = (eventId) => `${adminEventRoute(eventId)}/tournaments`;
export const adminEventTournamentRoute = (eventId, tournamentId) =>
  `${adminEventTournamentsRoute(eventId)}/${tournamentId}`;
export const publicEventRoute = (eventId) => `${ROUTES.PUBLIC.EVENT}/${eventId}`;
export const publicEventBoardRoute = (eventId, { club } = {}) =>
  `${publicEventRoute(eventId)}/board${club ? `?club=${encodeURIComponent(club)}` : ""}`;
export const isPublicEventBoardPath = (pathname) => /^\/event\/[^/]+\/board\/?$/.test(pathname || "");
export const publicTournamentRoute = (tournamentId) => `${ROUTES.PUBLIC.TOURNAMENT}/${tournamentId}`;
